<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="600">
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ titleMode }} Registro de Campañas
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true }
          }"
        >
          <v-card-text style="max-height: 370px">
            <v-form>
              <v-row dense>
                <!-- Nombre -->
                <v-col cols="12">
                  <ValidationProvider
                    name="Nombre"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre"
                      name="name"
                      prepend-inner-icon="mdi-label-variant"
                      type="text"
                      color="blue-grey"
                      v-model="formData.name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <!-- DNI -->
                <v-col cols="12">
                  <ValidationProvider
                    name="DNI"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="DNI"
                      name="dni"
                      prepend-inner-icon="mdi-card-account-details"
                      type="text"
                      color="blue-grey"
                      v-model="formData.dni"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <!-- Direccion -->
                <v-col cols="12">
                  <ValidationProvider
                    name="Direccion"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Direccion"
                      name="direction"
                      prepend-inner-icon="mdi-directions"
                      type="text"
                      color="blue-grey"
                      v-model="formData.direction"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <!-- Pais -->
                <v-col cols="12">
                  <ValidationProvider
                    name="Pais"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Pais"
                      name="country"
                      prepend-inner-icon="mdi-earth"
                      type="text"
                      color="blue-grey"
                      v-model="formData.country"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Agente -->
                <v-col cols="12">
                  <ValidationProvider
                    name="asignar agente"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      v-model="formData.user_id"
                      :items="AgentList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      class="rounded-small"
                      placeholder="Asignar agente"
                      filled
                      rounded
                    ></v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Status Register -->
                <v-col cols="12">
                  <ValidationProvider
                    name="Estado del registro"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      v-model="formData.status_register_id"
                      :items="statusRegisterList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      class="rounded-small"
                      placeholder="Estado de Registro"
                      filled
                      rounded
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <!-- Phones -->
                <v-col
                  cols="12"
                  class="d-flex"
                  v-for="item in phoneCounter"
                  :key="item"
                >
                  <v-col cols="10" class="pl-0">
                    <ValidationProvider
                      :name="`Telefono${item}`"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        :label="`Telefono ${item}`"
                        :name="`tlf${item}`"
                        prepend-inner-icon="mdi-card-account-details"
                        type="text"
                        color="blue-grey"
                        v-model="formData[`telefono${item}`]"
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    cols="2"
                    class="d-flex justify-center"
                    v-if="item === phoneCounter && item > 1"
                  >
                    <v-btn class="mt-1" @click="removePhone" icon rounded>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn @click="addPhone" icon rounded>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
                <!-- Variables -->
                <v-col
                  cols="12"
                  class="d-flex"
                  v-for="item in varCounter"
                  :key="`var${item}`"
                >
                  <v-col cols="10" class="pl-0">
                    <ValidationProvider
                      :name="`Variable${item}`"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        :label="`Variable ${item}`"
                        :name="`var${item}`"
                        prepend-inner-icon="mdi-card-account-details"
                        type="text"
                        color="blue-grey"
                        v-model="formData[`var${item}`]"
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="2" v-if="item === varCounter && item > 1">
                    <v-btn @click="removeVar" class="mt-1" icon rounded>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn @click="addVar" icon rounded>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog(null)"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
              >{{ submitButtonMode }}</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";

export default {
  components: { vuescroll },
  props: {
    dialog: {
      type: Boolean
    },
    editMode: {
      type: Boolean,
      default: false
    },
    axios: {
      type: Function
    },
    data: {
      type: Object
    },
    statusRegisterList: {
      type: Array
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      isLoading: false,
      dateMenu: false,
      date2Menu: false,
      phoneCounter: this.editMode ? this.getPhonesQuantity() : 1,
      varCounter: this.editMode ? this.getVarQuantity() : 1,
      titleMode: this.editMode ? "Actualizar" : "Crear",
      submitButtonMode: this.editMode ? "Guardar" : "Crear",
      formData: this.editMode
        ? this.data
        : {
            campaign_id: Number(this.id),
            name: "",
            dni: "",
            direction: "",
            country: "",
            telefono1: "",
            status_register_id: null,
            var1: ""
          }
    };
  },

  computed: {
    AgentList() {
      return this.$store.getters["agents/GET_ALL_AGENTS"];
    }
  },

  created() {
    if (!this.AgentList.length) this.$store.dispatch("agents/GET_ALL_AGENTS");
  },

  methods: {
    addPhone() {
      if (this.phoneCounter == 10) return;
      this.phoneCounter = this.phoneCounter + 1;
      this.formData = {
        ...this.formData,
        [`telefono${this.phoneCounter}`]: ""
      };
    },
    removePhone() {
      if (this.phoneCounter === 1) return;
      this.phoneCounter = this.phoneCounter - 1;
      const {
        [`telefono${this.phoneCounter + 1}`]: key,
        ...formData
      } = this.formData;
      this.formData = formData;
    },
    addVar() {
      if (this.varCounter == 10) return;
      this.varCounter = this.varCounter + 1;
      this.formData = {
        ...this.formData,
        [`var${this.varCounter}`]: ""
      };
    },
    removeVar() {
      if (this.varCounter === 1) return;
      this.varCounter = this.varCounter - 1;
      const { [`var${this.varCounter + 1}`]: key, ...formData } = this.formData;
      this.formData = formData;
    },
    getPhonesQuantity() {
      let quantity = 0;
      for (const key in this.data)
        if (key.includes("telefono") && this.data[key]) quantity += 1;
      return quantity;
    },
    getVarQuantity() {
      let quantity = 0;
      for (const key in this.data)
        if (key.includes("var") && this.data[key]) quantity += 1;
      return quantity;
    },
    closeDialog(item) {
      this.$emit("dialog:close", item);
    },
    async submitForm() {
      this.isLoading = true;
      try {
        let data;
        if (this.editMode) {
          const { id, ...payload } = this.formData;
          const res = await this.axios.put(
            `/campaign/register/${this.data.id}`,
            payload
          );
          // console.log("updated register:", data);
          data = res.data;
          this.$snotify.success("Actualizado con exito", "¡Hecho!");
        } else {
          await this.axios.post("/campaign/register", this.formData);
          this.$snotify.success("Creado con exito", "¡Hecho!");
        }
        this.closeDialog(data);
      } catch (err) {
        this.$snotify.error("Hubo un error guardando la campaña", "¡Error!");
        // console.log("Error in post:", err);
      }
      this.isLoading = false;
    }
  }
};
</script>

<style></style>
